module.exports = __webpack_public_path__ + "img/US_CavalryDPS_ua.4b215954.webp";